import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Replace, Boxes, History } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import { useLocalePath } from '../layout/LanguageRoute'

/**
 * Three task entrances (homepage-v2, T3.2 §6.1.2). Each maps a real customer
 * job to the shortest path: replace a part → the catalog; build a system →
 * browse by category; find a successor for a phased-out part → the legacy view
 * (?legacy=only surfaces only discontinued products, where a successor is shown
 * when known).
 */
interface Entry {
  key: string
  icon: LucideIcon
  to: string
}

const ENTRIES: Entry[] = [
  { key: 'replace', icon: Replace, to: '/products' },
  { key: 'build', icon: Boxes, to: '/products#producten' },
  { key: 'legacy', icon: History, to: '/products?legacy=only' },
]

export default function TaskEntryCards() {
  const { t } = useTranslation()
  const lp = useLocalePath()

  return (
    <section className="py-12 border-t border-neutral-100">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {ENTRIES.map(({ key, icon: Icon, to }) => (
          <Link
            key={key}
            to={lp(to)}
            className="flex flex-col gap-3 rounded-xl border border-gcg-border bg-white p-6 hover:border-primary hover:-translate-y-px transition-all duration-150"
          >
            <div className="flex items-center justify-center h-10 w-10 rounded-full bg-gcg-tint shrink-0">
              <Icon className="h-5 w-5 text-primary" />
            </div>
            <div>
              <h3 className="font-bold text-gcg-text mb-1">{t(`shop.homeV2.tasks.${key}Title`)}</h3>
              <p className="text-sm text-neutral-600 leading-relaxed">{t(`shop.homeV2.tasks.${key}Body`)}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  )
}
